import { PayoutOrderPublicStatus } from '~/entities/payout';

export const filters = {
    publicStatuses: [PayoutOrderPublicStatus.PUBLIC_STATUS_CREATED, PayoutOrderPublicStatus.PUBLIC_STATUS_PENDING],
};
